<div class="app-rows-section">
    <div class="app-rows-section__toolbar d-flex justify-content-between align-items-center mb-2">
        <span class="app-rows-section__title fw-semibold">{{ titleKey() | localize }}</span>
        <button type="button"
                class="btn btn-sm btn-outline-primary"
                (click)="addRow.emit()"
                [disabled]="addDisabled()">
            + {{ addLabelKey() | localize }}
        </button>
    </div>

    <ng-content select="[rowsSectionAlerts]"></ng-content>

    <div class="app-rows-section__header row g-2 d-none d-md-flex">
        @for (column of columns(); track column.labelKey) {
        <div [class]="column.colClass">
            <span class="text-muted small">{{ column.labelKey | localize }}</span>
        </div>
        }
        <div class="col-md-1"></div>
    </div>

    @for (rowIndex of rowIndexes(); track rowIndex) {
    <div class="app-rows-section__row row g-2 align-items-start">
        <ng-container *ngTemplateOutlet="rowTemplate(); context: { $implicit: rowIndex }"></ng-container>
        <div class="col-12 col-md-1 d-flex justify-content-center pt-1">
            <button type="button"
                    class="btn btn-sm btn-outline-danger"
                    (click)="removeRow.emit(rowIndex)"
                    [disabled]="!canRemove()">
                <i class="fas fa-trash"></i>
            </button>
        </div>
    </div>
    }
</div>
